

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { StorageService } from './storage.service';
import { Auth } from '../models/core/auth.model';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class AuthService {

	constructor(
		public _http: HttpClient,
		public _storage: StorageService,
	) {
	}

	/**
	 * Login
	 */
	public login(credential: string, password: string): Observable<Auth> {
		const url = `${environment.api_server}/api/v2/auth/login`;

		const emailRegex =
			/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

		const data: {
			app: 'box';
			password: string;
			email?: string;
			username?: string;
		} = {
			app: 'box',
			password,
		};

		if (emailRegex.test(credential)) {
			data.email = credential;
		} else {
			data.username = credential;
		}

		return this._http.post<Auth>(url, data);
	}


	/**
	 * Save login
	 */
	async saveLogin(data: Auth) {
		return await this._storage.set('user_data', data);
	}

	/**
	 * Logout
	 */
	async logout() {
		await this._storage.remove('user_data');
	}

	/**
	 * Login
	 */
	async getLogin(): Promise<Auth | null> {
		let res = await this._storage.get('user_data');

		if (res && res.user) {
			return res;
		}

		return null;
	}

	/**
	 * Verify login
	 */
	async isLoggedIn(): Promise<boolean> {
		let res = await this.getLogin();

		return res != null ? true : false;
	}

}
